/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
 // autogenerated file, do not change manually...
import FooterWrapper from './../components/Footer/FooterWrapper';
import HeaderWrapper from './../components/Header/HeaderWrapper';
import ProductListWrapper from './../components/Category/Magnolia/ProductListWrapper';
import BrandsWrapper from './../components/Footer/Brands/BrandsWrapper';
import CategoriesWrapper from './../components/Footer/Categories/CategoriesWrapper';
import FooterColumnWrapper from './../components/Footer/FooterColumn/FooterColumnWrapper';
import FooterLinkWrapper from './../components/Footer/FooterLink/FooterLinkWrapper';
import FooterSocialWrapper from './../components/Footer/FooterSocial/FooterSocialWrapper';
import BannerWrapper from './../components/Header/Banner/BannerWrapper';
import TopBarWrapper from './../components/Header/TopBar/TopBarWrapper';
import AccordionWrapper from './../components/Shared/Accordion/AccordionWrapper';
import BigCardCarouselWrapper from './../components/Shared/BigCardCarousel/BigCardCarouselWrapper';
import BrochureViewerWrapper from './../components/Shared/BrochureViewer/BrochureViewerWrapper';
import ExpandableWrapper from './../components/Shared/Expandable/ExpandableWrapper';
import GridLayoutWrapper from './../components/Shared/GridLayout/GridLayoutWrapper';
import HeroCarouselWrapper from './../components/Shared/HeroCarousel/HeroCarouselWrapper';
import PlayableWrapper from './../components/Shared/Playable/PlayableWrapper';
import PrivacyPolicyEmbeddingWrapper from './../components/Shared/PrivacyPolicyEmbedding/PrivacyPolicyEmbeddingWrapper';
import SealsWrapper from './../components/Shared/Seals/SealsWrapper';
import TileDisplayWrapper from './../components/Shared/TileDisplay/TileDisplayWrapper';
import TilesWrapper from './../components/Shared/Tiles/TilesWrapper';
import FragmentsPage from './../templates/pages/FragmentsPage/FragmentsPage';
import HomePage from './../templates/pages/HomePage/HomePage';
import InfoPage from './../templates/pages/InfoPage/InfoPage';
import Redirect from './../templates/pages/Redirect/Redirect';
import BrandImageWrapper from './../components/Footer/Brands/BrandImage/BrandImageWrapper';
import FormWrapper from './../components/Shared/Forms/Form/FormWrapper';
import ParagraphWrapper from './../components/Shared/Forms/Paragraph/ParagraphWrapper';
import RTEWrapper from './../components/Shared/Magnolia/RTE/RTEWrapper';
import ButtonWrapper from './../components/Shared/MagnoliaElements/Button/ButtonWrapper';
import ColumnWrapper from './../components/Shared/MagnoliaElements/Column/ColumnWrapper';
import ImageWrapper from './../components/Shared/MagnoliaElements/Image/ImageWrapper';
import MediaWrapper from './../components/Shared/MagnoliaElements/Media/MediaWrapper';
import TextWrapper from './../components/Shared/MagnoliaElements/Text/TextWrapper';
import CardContentWrapper from './../components/Shared/Teaser/CardContent/CardContentWrapper';
import TopWrapper from './../components/Shared/Teaser/Categories/TopWrapper';
import TeaserSliderWrapper from './../components/Shared/Teaser/Slider/TeaserSliderWrapper';
import StageTeaserWrapper from './../components/Shared/Teaser/Stage/StageTeaserWrapper';
import ThemeSliderBigWrapper from './../components/Shared/Slider/Big/ThemeSliderBig/ThemeSliderBigWrapper';
import ThemeSliderSmallWrapper from './../components/Shared/Slider/Small/ThemeSliderSmall/ThemeSliderSmallWrapper';
import StageTeaserV2Wrapper from './../components/Shared/Teaser/Stage/v2/StageTeaserV2Wrapper';
import OneCTTextImageHalfWrapper from './../components/Shared/Teaser/Columns/One/TextImageHalf/OneCTTextImageHalfWrapper';
import OneCTImageWrapper from './../components/Shared/Teaser/Columns/One/Image/OneCTImage/OneCTImageWrapper';
import OneCTTextWrapper from './../components/Shared/Teaser/Columns/One/Text/OneCTText/OneCTTextWrapper';
import OneCTTextImageFullWrapper from './../components/Shared/Teaser/Columns/One/TextImageFull/OneCTTextImageFull/OneCTTextImageFullWrapper';
import ThreeCTWrapper from './../components/Shared/Teaser/Columns/Three/Frame/ThreeCT/ThreeCTWrapper';
import TwoCTWrapper from './../components/Shared/Teaser/Columns/Two/Frame/TwoCT/TwoCTWrapper';

const config = {
    workspace: '',
    'componentMappings': {
        'kikstorefront:components/Footer/Footer': FooterWrapper,
        'kikstorefront:components/Header/Header': HeaderWrapper,
        'kikstorefront:components/Category/Magnolia/ProductList': ProductListWrapper,
        'kikstorefront:components/Footer/Brands/Brands': BrandsWrapper,
        'kikstorefront:components/Footer/Categories/Categories': CategoriesWrapper,
        'kikstorefront:components/Footer/FooterColumn/FooterColumn': FooterColumnWrapper,
        'kikstorefront:components/Footer/FooterLink/FooterLink': FooterLinkWrapper,
        'kikstorefront:components/Footer/FooterSocial/FooterSocial': FooterSocialWrapper,
        'kikstorefront:components/Header/Banner/Banner': BannerWrapper,
        'kikstorefront:components/Header/TopBar/TopBar': TopBarWrapper,
        'kikstorefront:components/Shared/Accordion/Accordion': AccordionWrapper,
        'kikstorefront:components/Shared/BigCardCarousel/BigCardCarousel': BigCardCarouselWrapper,
        'kikstorefront:components/Shared/BrochureViewer/BrochureViewer': BrochureViewerWrapper,
        'kikstorefront:components/Shared/Expandable/Expandable': ExpandableWrapper,
        'kikstorefront:components/Shared/GridLayout/GridLayout': GridLayoutWrapper,
        'kikstorefront:components/Shared/HeroCarousel/HeroCarousel': HeroCarouselWrapper,
        'kikstorefront:components/Shared/Playable/Playable': PlayableWrapper,
        'kikstorefront:components/Shared/PrivacyPolicyEmbedding/PrivacyPolicyEmbedding': PrivacyPolicyEmbeddingWrapper,
        'kikstorefront:components/Shared/Seals/Seals': SealsWrapper,
        'kikstorefront:components/Shared/TileDisplay/TileDisplay': TileDisplayWrapper,
        'kikstorefront:components/Shared/Tiles/Tiles': TilesWrapper,
        'kikstorefront:pages/FragmentsPage/FragmentsPage': FragmentsPage,
        'kikstorefront:pages/HomePage/HomePage': HomePage,
        'kikstorefront:pages/InfoPage/InfoPage': InfoPage,
        'kikstorefront:pages/Redirect/Redirect': Redirect,
        'kikstorefront:components/Footer/Brands/BrandImage/BrandImage': BrandImageWrapper,
        'kikstorefront:components/Shared/Forms/Form/Form': FormWrapper,
        'kikstorefront:components/Shared/Forms/Paragraph/Paragraph': ParagraphWrapper,
        'kikstorefront:components/Shared/Magnolia/RTE/RTE': RTEWrapper,
        'kikstorefront:components/Shared/MagnoliaElements/Button/Button': ButtonWrapper,
        'kikstorefront:components/Shared/MagnoliaElements/Column/Column': ColumnWrapper,
        'kikstorefront:components/Shared/MagnoliaElements/Image/Image': ImageWrapper,
        'kikstorefront:components/Shared/MagnoliaElements/Media/Media': MediaWrapper,
        'kikstorefront:components/Shared/MagnoliaElements/Text/Text': TextWrapper,
        'kikstorefront:components/Shared/Teaser/CardContent/CardContent': CardContentWrapper,
        'kikstorefront:components/Shared/Teaser/Categories/Top': TopWrapper,
        'kikstorefront:components/Shared/Teaser/Slider/TeaserSlider': TeaserSliderWrapper,
        'kikstorefront:components/Shared/Teaser/Stage/StageTeaser': StageTeaserWrapper,
        'kikstorefront:components/Shared/Slider/Big/ThemeSliderBig/ThemeSliderBig': ThemeSliderBigWrapper,
        'kikstorefront:components/Shared/Slider/Small/ThemeSliderSmall/ThemeSliderSmall': ThemeSliderSmallWrapper,
        'kikstorefront:components/Shared/Teaser/Stage/v2/StageTeaserV2': StageTeaserV2Wrapper,
        'kikstorefront:components/Shared/Teaser/Columns/One/TextImageHalf/OneCTTextImageHalf': OneCTTextImageHalfWrapper,
        'kikstorefront:components/Shared/Teaser/Columns/One/Image/OneCTImage/OneCTImage': OneCTImageWrapper,
        'kikstorefront:components/Shared/Teaser/Columns/One/Text/OneCTText/OneCTText': OneCTTextWrapper,
        'kikstorefront:components/Shared/Teaser/Columns/One/TextImageFull/OneCTTextImageFull/OneCTTextImageFull': OneCTTextImageFullWrapper,
        'kikstorefront:components/Shared/Teaser/Columns/Three/Frame/ThreeCT/ThreeCT': ThreeCTWrapper,
        'kikstorefront:components/Shared/Teaser/Columns/Two/Frame/TwoCT/TwoCT': TwoCTWrapper,
    },
    'fallbackLocale': 'en-GB',
    'locales': [
        'en-GB',
        'de-DE',
    ],
};

export default config;
